import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  Space,
  Select,
  DatePicker,
  Table,
  Tooltip,
  Input,
  Col,
  Form,
  Popconfirm,
} from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import ExelDownload from "../../image/exeldownload.svg";
import { EyeOutlined, DownloadOutlined } from "@ant-design/icons";
import SearchIcon from "../../image/SearchIcon.svg";
import moment from "moment";
import { debounce } from "lodash";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { getRequest, postRequest } from "../../axios";
import { authUserData } from "../../utils/Helper";
import { ReactComponent as Archive } from "../../image/Archive.svg";

const { Search } = Input;

const FloatRFQAssignPR = () => {
  const { t } = useTranslation();
  const formRef = useRef();
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState([]);
  const [reload, setReload] = useState(false);
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [btnLoading, setBtnLoading] = useState(false);
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });
  const [prStatus, setPrStatus] = useState("");
  const [startDate, setStartDate] = useState("");
  const [assignBuyer, setAssignBuyer] = useState([]);
  const [endDate, setEndDate] = useState("");
  const [unassignedpr, setUnassignedPR] = useState("");
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  const { id } = useParams();
  const [totalCount, settotalCount] = useState(0);
  const CategoryId = id;

  const CompanyID = authUserData()?.company ? authUserData()?.company : null;

  const employee = authUserData()?.company ? authUserData()?.role[0].name.includes("company_") : null;

  const employeeID = authUserData()?.employee ? authUserData()?.employee : null;



  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Fetch currency symbol from API
    const getCurrency = async () => {
      try {
        const response = await getRequest("business-settings/get-currency-by-business-setting/");
        setCurrencySymbol(response.data.data); // Assuming the response contains the currency symbol in the 'data' field
      } catch (error) {
        console.error("Error fetching currency symbol:", error);
      }
    };

    // Call getCurrency to fetch currency symbol when needed
    getCurrency(); // Replace 'data' with appropriate data parameter for your API call
  }, []); // Empty dependency array ensures this effect runs only once after the initial render

  const handleApplyFilter = () => {
    // Assuming you have some way to get filter values from your UI
    // You can replace these placeholders with actual values from your UI state or input fields
    const filterParams = {
      pr_created_date__gte: startDate, // Get values from UI
      pr_created_date__lte: endDate,
      // unassigned_pr: unassignedpr,
      // pr_status: prStatus,
    };
    setState(filterParams);
  };

  const handleReset = () => {
    // setPoOrderPlaced([]);
    setPrStatus("");
    setUnassignedPR("");
    setEndDate("");
    setStartDate("");

    setState({
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
    formRef.current.setFieldsValue({
      pr_created_date__gte: null,
      pr_status: null,
      unassigned_pr: null,
      pr_created_date__lte: null,
    });
  };


  const handleStartDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YYYY");
    setStartDate(formattedDate);
  };

  const handleEndDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YYYY");
    setEndDate(formattedDate);
  };

  const handleSelectChange = (value) => {
    setUnassignedPR(value);
  };

  const handleSelectPrStatusChange = (value) => {
    //  setState({ ...state, [name]: value });
    setPrStatus(value);
  };

  // const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  // const onSelectChange = (newSelectedRowKeys) => {
  //   setSelectedRowKeys(newSelectedRowKeys);
  // };
  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: onSelectChange,
  // };
  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRow(selectedRowKeys);
    },
  };
  useEffect(() => {
    const getAssignBuyer = async (data) => {
      await getRequest(
        `purchase-requisition/assign-to-buyer/${id}`, data
      ).then((response) => {
        setAssignBuyer(response.data.results.data);
      });
    };
    getAssignBuyer();
  }, [id]);

  // const handleAssignToBuyerChange = async (value, record) => {
  //   confirmAlert({
  //     title: "Confirm",
  //     message: "Are you sure you want to save changes?",
  //     buttons: [
  //       {
  //         label: "Yes",
  //         onClick: () => saveAssignToBuyer(value, record.id),
  //       },
  //       {
  //         label: "No",
  //         onClick: () => Errornotificationmsg("Cancelled"),
  //       },
  //     ],
  //   });
  // };

  // const saveAssignToBuyer = async (value, id) => {
  //   try {
  //     // Make the patch request to update the value
  //     await patchRequest(
  //       `purchase-requisition/${id}/pr-assign-to-buyer/`,
  //       { pr_assign_to_buyer: value }
  //     );
  //     // Update the state or data accordingly
  //     // For example, you can update the assignBuyer state
  //     // const updatedAssignBuyer = assignBuyer.map((option) => {
  //     //   if (option.pr_assign_to_buyer === value) {
  //     //     return { ...option, selected: true };
  //     //   } else {
  //     //     return { ...option, selected: false };
  //     //   }
  //     // });
  //     // setAssignBuyer(updatedAssignBuyer);
  //     SuccessNotificationMsg(t("pr_assign_to_buyer_successfully"));
  //     setReload(!reload);
  //     setLoading(false);

  //   } catch (error) {
  //     console.error("Error updating assignee:", error);
  //   }
  // };

  const handleFloatRFQ = async (selectedRowIds = [], id = "") => {
    let ids = [...selectedRowIds]; // Assuming selectedRowIds contains the IDs
    if (id) {
      ids.push(id); // Add the provided id to the array if it exists
    }
    try {
      setBtnLoading(true);
      let apiResponse = await postRequest(`float-rfq/`, {
        company: CompanyID,
        category_tree: parseInt(CategoryId),
        purchase_requisition_master: ids, // Assuming ids contains the purchase requisition master IDs
      });

      const responseId = apiResponse.data.data.id; // Assuming the response has an ID field
      // Pass the response ID to the page you want to navigate to
      navigate(`/request-for-quotation/add-rfq/${responseId}`);

    } catch (error) {
      console.error("Error:", error);
      setBtnLoading(false);
      // Handle error...
    }
  };
  const handleArchive = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("purchase-requisition-archive/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("assign_pr_archive_successfully"));
        setReload(!reload);
        setSelectedRow([]);

      } else {
        ErrorNotificationMsg(t("error_in_archive_assign_pr"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };


  const columns = [
    {
      title: "category",
      dataIndex: "category_tree_name",
      key: "category_tree_name",
      sorter: true,
    },
    {
      title: "PR Creator",
      dataIndex: "pr_creator",
      key: "pr_creator",
      sorter: true,
    },
    {
      title: "PR Number",
      dataIndex: "pr_number",
      key: "pr_number",
      sorter: true,
    },
    // {
    //   title: "Approval Date",
    //   dataIndex: "pr_approval_date",
    //   key: "pr_approval_date",
    //   sorter: true,
    // },
    // {
    //   title: "Estimated PR Value",
    //   dataIndex: "total_amount",
    //   key: "total_amount",
    //   sorter: true,
    // },
    {
      title: `Estimated PR Value (${currencySymbol})`,
      dataIndex: "total_amount",
      key: "total_amount",
      sorter: true,
      render: (value) => <span>{currencySymbol} {value}</span>
      //render: (value) => <span> ₹ {value} </span>,
    },
    {
      title: "Assign to buyer",
      width: "160px",
      dataIndex: "pr_assign_to_buyer",
      key: "pr_assign_to_buyer",
      sorter: true,
      // render: (e, record) => (
      //   <div className="SelectStatusSec">

      //   <Select
      //     defaultValue={uomOptions.length > 0 ? uomOptions[0].value : ''}
      //     defaultValue=""
      //     value={e ? e : record.pr_assign_to_buyer}
      //     defaultValue={e}
      //     style={{ width: 120 }}
      //     disabled

      //     onChange={(e) => handleAssignToBuyerChange(e, record)}
      //   >
      //   </Select>
      //   </div>
      // ),
    },
    {
      title: "RFQ Status",
      dataIndex: "pr_status_for_rfq",
      key: "pr_status_for_rfq",
      sorter: true,
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (record) => (
        <Space>
          <Tooltip title="View PR">
            <Link to={`/float-rfq-purchase-requisition-assign-details/${record.id}`}>
              <EyeOutlined />
            </Link>
          </Tooltip>
          <Tooltip title="Download PR">
            <DownloadOutlined onClick={() => handleDownload(record.id)} />
          </Tooltip>
          <Popconfirm
            className="action"
            title={t("pop_title")}
            okText={t("pop_ok")}
            cancelText={t("pop_cancel")}
            onConfirm={() => handleArchive(record.id)}
          >
            <Archive style={{ cursor: "pointer" }} />
          </Popconfirm>
        </Space>
      ),
    },
  ];
  const [
    purchaseRequisitionFloatRFQAssignPR,
    setPurchaseRequisitionFloatRFQAssignPR,
  ] = useState([]);
  useEffect(() => {
    const getPurchaseRequisitionDetails = async () => {
      setLoading(true);

      try {

        let apiResponse;

        if (!employee) {
          apiResponse = await getRequest(
            `purchase-requisition/${CompanyId}/pr-by-company-id/?pr_status=Approve&pr_assign_to_buyer=assigned&category_id=${id}`, state
          );
        } else {
          apiResponse = await getRequest(
            `purchase-requisition/${CompanyId}/pr-by-company-id/?pr_status=Approve&pr_assign_to_buyer=assigned&category_id=${id}&pr_assign_employee=${employeeID}`, state
          );
        }


        if (apiResponse.data.results.data) {
          setPurchaseRequisitionFloatRFQAssignPR(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_purchase_requisition"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getPurchaseRequisitionDetails();
  }, [reload, CompanyId, t, state]);

  const handleExcelDownload = async () => {
    // const endpoint = `purchase-requisition/${CompanyID}/download-company-pr-history-excel/`;
    const endpoint = `purchase-requisition/${CompanyID}/download-company-pr-approved-history-excel?pr_status=Approve&category_id=${id}`
    const fileType = "csv";

    try {
      await getRequest(endpoint)
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "text/csv",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          //link.download = `purchase_requisition_${id}-${+new Date()}.${fileType}`;
          link.download = `purchase_requisition_${CompanyID}-${+new Date()}.${fileType}`;
          link.click();
        })
        .catch((error) => {
          //ErrorNotificationMsg(t(`err_${fileType}_download`));
        });
    } catch (error) {
      //ErrorNotificationMsg(error);
    }
  };

  const handleDownload = async (prNumber) => {
    try {
      const endpoint = `purchase-requisition/${prNumber}/download-single-pr-history-excel/`;
      const response = await getRequest(endpoint);
      const blob = new Blob([response.data], {
        type: "text/csv", // Set MIME type to text/csv for CSV file
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `purchase_requisition_${prNumber}-${+new Date()}.csv`; // Set file extension to .csv
      link.click();
    } catch (error) {
      ErrorNotificationMsg("Error downloading PR");
    }
  };
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };
  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };
  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };
  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "category_tree_name" && sortOrder === "ascend") {
      sortingEnumKey = "category_tree_name";
    }
    if (sortField === "category_tree_name" && sortOrder === "descend") {
      sortingEnumKey = "-category_tree_name";
    }
    if (sortField === "pr_creator" && sortOrder === "ascend") {
      sortingEnumKey = "pr_creator";
    }
    if (sortField === "pr_creator" && sortOrder === "descend") {
      sortingEnumKey = "-pr_creator";
    }
    if (sortField === "pr_number" && sortOrder === "ascend") {
      sortingEnumKey = "pr_number";
    }
    if (sortField === "pr_number" && sortOrder === "descend") {
      sortingEnumKey = "-pr_number";
    }
    if (sortField === "pr_approval_date" && sortOrder === "ascend") {
      sortingEnumKey = "pr_approval_date";
    }
    if (sortField === "pr_approval_date" && sortOrder === "descend") {
      sortingEnumKey = "-pr_approval_date";
    }
    if (sortField === "total_amount" && sortOrder === "ascend") {
      sortingEnumKey = "total_amount";
    }
    if (sortField === "total_amount" && sortOrder === "descend") {
      sortingEnumKey = "-total_amount";
    }
    if (sortField === "rfqstatus" && sortOrder === "ascend") {
      sortingEnumKey = "rfqstatus";
    }
    if (sortField === "rfqstatus" && sortOrder === "descend") {
      sortingEnumKey = "-rfqstatus";
    }

    return sortingEnumKey;
  };
  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Notify selected suppliers about the RFQ via email or through the procurement platform,
                  ensuring prompt attention and response.
                </span>
              }
            >
              <h3> {t("assign_pr")} </h3>
            </Tooltip>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              {/* <Breadcrumb.Item> <Link to="/request-for-quotation/add">Float RFQ</Link></Breadcrumb.Item> */}
              <Breadcrumb.Item>{t("assign_pr")} </Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                />
              </Space>
            </div>
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleArchive()}
              >

                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label={t("pl_Archive")}
                />

              </Popconfirm>
            )}
            <Tooltip placement="topLeft" title="Archived Records">
              <Link to={`/request-for-quotation/float-rfq-assign-pr/archive/${CategoryId}`} className="Archiveicon">
                <Archiveicon />
              </Link>
            </Tooltip>
          </Space>
        </div>
      </div>
      <section className="grid-sec mt-5">
        <div className="PR-body">
          <div className="filterrow">
            <div className="filtercol">
              <Form autoComplete="off" ref={formRef}>
                <Space wrap>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item
                      name="unassigned_pr"
                    // label="PO Order Placed"
                    //initialValue={state.maximum_income}
                    >
                      <Select
                        showArrow
                        showSearch
                        allowClear
                        placeholder="Unassigned PR"
                        value={state.unassignedpr}
                        onChange={(value) =>
                          //handleSelectChange("unassigned_pr", value)
                          handleSelectChange(value)
                        }
                        optionFilterProp="children"
                      >
                        <Select.Option value="Yes">Yes</Select.Option>
                        <Select.Option value="No">No</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item
                      name="pr_status"
                      style={{ width: "120px" }}
                    // label="PO Order Placed"
                    //initialValue={state.maximum_income}
                    >
                      <Select
                        showArrow
                        showSearch
                        allowClear
                        placeholder="PR status"
                        value={state.prStatus}
                        onChange={(value) =>
                          // handleSelectChange("pr_status", value)
                          handleSelectPrStatusChange(value)
                        }
                        optionFilterProp="children"
                      >
                        <Select.Option value="Approve">Approve</Select.Option>
                        <Select.Option value="Pending">Pending</Select.Option>
                        <Select.Option value="Reject">Reject</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item
                      name="prageing"
                    //label={t("label_category")}
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: <Trans>{t("val_category_tree")}</Trans>,
                    //   },
                    // ]}
                    >
                      <Select
                        showArrow
                        showSearch
                        allowClear
                        placeholder="PR Ageing Report"
                        optionFilterProp="children"
                      // onChange={(value) =>
                      //  setState({ ...state, category_tree: value })
                      // }
                      >
                        {/* {categoryTree &&
                  categoryTree.length > 0 &&
                  categoryTree.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))} */}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item name="pr_created_date__gte">
                      <DatePicker
                        // showTime
                        format="DD-MM-YYYY"
                        value={startDate}
                        onChange={handleStartDateChange}
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item name="pr_created_date__lte">
                      <DatePicker
                        // showTime
                        format="DD-MM-YYYY"
                        value={endDate}
                        onChange={handleEndDateChange}
                      />
                    </Form.Item>
                  </Col>
                </Space>
              </Form>
            </div>
            <div className="btnscol">
              <Space>
                {endDate || startDate || unassignedpr || prStatus ? (
                  <>
                    <ButtonField
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="Apply"
                      label="Apply"
                      onClick={handleApplyFilter}
                    />
                    <ButtonField
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="button"
                      label="Reset"
                      onClick={handleReset}
                    //onClick={() => handleFloatRFQ(selectedRow)}
                    />
                  </>
                ) : ""}
                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="Excel"
                  label="Excel"
                  onClick={handleExcelDownload}
                  icon={<img src={ExelDownload} alt="Plus Square" />}
                />
              </Space>
            </div>
          </div>
          <Table
            columns={columns}
            loading={loading}
            dataSource={purchaseRequisitionFloatRFQAssignPR}
            rowKey={(record) => record.id}
            rowSelection={rowSelection}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: 'Items / Page', // Text for the size changer
              },
            }}
            // scroll={{
            //   x: 1000,
            // }}
            onChange={handleTableChange}
            
          />
          <div className="btnwrp">

            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              htmlType="button"
              label="Float RFQ"
              onClick={() => handleFloatRFQ(selectedRow)}
              loading={btnLoading}
            />

          </div>
        </div>
      </section>
    </>
  );
};
export default FloatRFQAssignPR;
